/**
 *
 */
export default class CellConfig {
    /**
     * @param {{}} settings
     */
    constructor(settings = {}) {
        Object.assign(this, {
            ...settings,
        });
    }
}
